var map = {
	"./logo-eu.svg": 748,
	"./logo-frcito.svg": 173,
	"./logo-irop.svg": 864,
	"./logo-mas-footer.svg": 358,
	"./logo-masbohdanecsko.svg": 26,
	"./logo-votocto.svg": 145,
	"./pikto-email.svg": 382,
	"./pikto-fb.svg": 143,
	"./pikto-tel.svg": 852,
	"./pikto-web.svg": 243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;